import { render, staticRenderFns } from "./WalletTransactions.vue?vue&type=template&id=33fc993a&scoped=true"
import script from "./WalletTransactions.vue?vue&type=script&lang=js"
export * from "./WalletTransactions.vue?vue&type=script&lang=js"
import style0 from "./WalletTransactions.vue?vue&type=style&index=0&id=33fc993a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc993a",
  null
  
)

export default component.exports